import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpBackend, provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideNgxStripe } from 'ngx-stripe';
import { environment } from '../environments/environment';
import { NgxLoadingModule } from "ngx-loading";
import { LoadingInterceptor } from './interceptors/loading.interceptor';
import { HttpInterceptorFn } from '@angular/common/http';
import { LoadingService } from './services/loading.service';
import { TranslateLoader, TranslateModule, TranslateStore } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { AuthInterceptor } from './auth.interceptor';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
//import Material from '@primeng/themes/material';

export const spinnerInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req);
};

export function HttpLoaderFactory(_httpBackend: HttpBackend) {
  return new MultiTranslateHttpLoader(_httpBackend, ['/assets/i18n/core/']);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.my-app-dark'
        }
      }
    }),
    LoadingService,
    provideRouter(routes), provideClientHydration(),
    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi(),
      withInterceptors([spinnerInterceptor])
    ),
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    importProvidersFrom([
      BrowserAnimationsModule,
      NgxLoadingModule.forRoot({}),
      TranslateModule.forChild({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpBackend]
        },
        defaultLanguage: 'el',
        isolate: true,
      }),
    ]),
    TranslateStore,
    provideNgxStripe(environment.stripeKey)
  ]
};
